import { render } from "./Receipt.vue?vue&type=template&id=1b8e8408&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=1b8e8408&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8e8408"]])

export default __exports__